import { useState, useEffect } from "react";
import Sidebar from "../../components/layout/Sidebar";
import Header from "../../components/layout/Header";
import { Outlet } from "react-router-dom";
import { primaryColor, secondaryColor } from "../../utils/comon";
import { darkTheme, lightTheme } from "../../utils/themeConfig";

const MainLayout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("theme") === "dark"
  );

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  useEffect(() => {
    const root = document.documentElement;
    const theme = isDarkMode ? darkTheme : lightTheme;

    // Apply active theme colors dynamically as CSS variables
    Object.entries(theme).forEach(([key, value]) => {
      root.style.setProperty(`--color-${key}`, value);
    });

    if (isDarkMode) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }

    // Dispatch global themeChanged event for charts and nested components to update
    window.dispatchEvent(new Event("themeChanged"));
  }, [isDarkMode]);

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-appbg">

      {/* Header */}
      <Header 
        toggleSidebar={toggleSidebar} 
        isSidebarOpen={isSidebarOpen} 
        isDarkMode={isDarkMode} 
        setIsDarkMode={setIsDarkMode} 
      />

      <div className="flex flex-1 overflow-hidden relative">

        {/* Desktop Sidebar */}
        <div
          className={`hidden lg:block flex-shrink-0 
          transition-all duration-500 ease-in-out
          ${isSidebarOpen ? "w-64" : "w-0 overflow-hidden"}`}
        >
          <Sidebar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
        </div>

        {/* Mobile Sidebar */}
        <div
          className={`fixed inset-0 z-40 lg:hidden ${isSidebarOpen ? "pointer-events-auto" : "pointer-events-none"
            }`}
        >

          {/* Overlay */}
          {isSidebarOpen && (
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setSidebarOpen(false)}
            />
          )}

          {/* Sidebar */}
          <div
            className={`absolute left-0 top-0 h-full w-64 bg-white shadow-lg pt-14
                        transform transition-transform duration-300 ease-in-out
                         ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}`}>
            <Sidebar
              toggleSidebar={toggleSidebar}
              closeSidebar={() => setSidebarOpen(false)}
            />
          </div>

        </div>

        <main className="flex-1 flex flex-col min-w-0 min-h-0 overflow-y-auto m-1 relative">

          {!isSidebarOpen &&
            <button
              onClick={toggleSidebar}
              className="
                   hidden lg:flex items-center justify-center
                   absolute top-10 left-0 z-20  shadow-md hover:shadow-lg
                   w-4 h-12 border rounded-r-lg
                   bg-white text-black
                   hover:bg-[var(--primary)] hover:text-white
                   transition-all duration-200"
              style={{ "--primary": primaryColor() }}>
              <span className="material-symbols-outlined">
                arrow_menu_open
              </span>
            </button>
          }
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;